import { bindable } from 'aurelia-framework';


export class Baloon {
  @bindable
  value: unknown;
}
